<template>
  <div class="mainBox">
      <h3>{{name}}</h3>
      <h4>{{date}}</h4>
      <div class="content">
        <img :src="url" v-if="isImg">

<!--        <div class="showVedio" v-if="isVedio">-->
          <video :src="url" controls="controls" v-if="isVedio">
            您的浏览器不支持 video 标签。
          </video>
<!--        </div>-->
        <div v-if="isLink">
            <h3>{{"网址："+url}}</h3>
        </div>
      </div>
  </div>
</template>

<script>
import time from "@/core/time";
import {ElLoading} from "element-plus";
export default {
  name: "FileDetails",
  components:{
    // videoPlayer
  },
  data(){
    return{
      isImg:true,
      isVedio:false,
      isLink:false,
      name:'',
      id:'',
      url:'',
      fileType:'',
      type:'',
      advice:'',
      state:'',
      Obj:{},
      //视频播放
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false,  // 如果为true,浏览器准备好时开始回放
        muted: false,     // 默认情况下将会消除任何音频。
        loop: false,      // 是否视频一结束就重新开始。
        preload: 'auto',  // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9',  // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true,  // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4",  // 类型
          src: ''             // url地址
        }],
        poster: '',  // 封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试',  // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,           // 当前时间和持续时间的分隔符
          durationDisplay: true,       // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true       // 是否显示全屏按钮
        }
      }
    }
  },
  created() {
  },
  mounted() {
    this.id=this.$route.query.id;
    this.filter();
  },
  methods:{
    filter(){
      let loadingInstance = null;
      loadingInstance = ElLoading.service({fullscreen: true});
      this.$request.post('/FileUpload/getDataById',this.id).then(data=>{
        // console.log(data)
        // //debugger
        this.date=time.formateDate((data.obj.createdDate))
        this.Obj=data.obj;
        this.name=this.Obj.name;
        this.url=window.location.origin+'/api3/'+this.Obj.url;
        // this.url=this.Obj.url;
        console.log(this.url)
        //debugger
        this.fileType=data.obj.fileType;
        if(this.fileType=='c'){
          this.isImg=true
          this.isVedio=false
          this.isLink=false
        }else if(this.fileType=='v'){
          this.isImg=false
          this.isVedio=true
          this.isLink=false
        }else if(this.fileType=='l'){
          this.isImg=false
          this.isVedio=false
          this.isLink=true
        }
        this.state=data.obj.state;

        loadingInstance.close();
      })

    }
  }
}
</script>

<style scoped lang="less">
.mainBox{
  h3{
    margin: 2%;
    text-align: center;
  }
  h4{
    text-align: center;
    margin: 2%;
  }
  .content{
    //height: 400px;
    //background-color: aqua;
    padding: 0 15%;
    text-align: center;
    img{
      height: 400px;
      //width: 500px;
      border: 2px solid red;
    }

    video{
      width: 60%;
      //height: 80%;
    }
  }
}

</style>
